import { useSelector } from 'react-redux';
import { Filter } from '@model/iceberg';
import { FiltersSideBar } from '@components/filters/v2/FiltersSideBar';
import React from 'react';
import { getFromPricePackageFilters, getFromPricePackagesHasAppliedFilters } from '@state/search-results';

export interface FiltersSideBarContainerProps {
  title?: boolean;
  onFiltersChange: (payload: Array<Filter>) => void;
  onFiltersReset: () => void;
}

export const FiltersSideBarContainer = (props: FiltersSideBarContainerProps) => {
  const { onFiltersChange, onFiltersReset } = props;
  const filters: Array<Filter> = useSelector(getFromPricePackageFilters);
  const hasAppliedFilters: boolean = useSelector(getFromPricePackagesHasAppliedFilters);

  return (
    <FiltersSideBar
      {...props}
      filters={filters}
      hasAppliedFilters={hasAppliedFilters}
      onChange={onFiltersChange}
      onReset={onFiltersReset}
    />
  );
};
